export default "__VITE_ASSET__DR5PIFms__"